export function createPolling() {
  return {
    start(timeoutId) {
      this.stop();
      this.timeoutId = timeoutId;
    },
    stop() {
      if (this.timeoutId) {
        this.timeoutId = clearTimeout(this.timeoutId);
      }
    },
  };
}
